import type { FC, HTMLAttributes, MouseEventHandler } from 'react';
import {
  ActionWrapper,
  CancelMeeting,
  Content,
  ContentWrapper,
  StartMeeting,
  Wrapper,
} from './style';

export type ModalProps = HTMLAttributes<HTMLDivElement> & {
  text?: string;
  onClickConfirm?: MouseEventHandler<HTMLButtonElement>;
  onClickCancel?: MouseEventHandler<HTMLButtonElement>;
};

const SolidModal: FC<ModalProps> = ({
  text,
  onClickConfirm,
  onClickCancel,
  ...props
}) => {
  return (
    <Wrapper>
      <Content {...props}>
        <ContentWrapper>{text}</ContentWrapper>
        <ActionWrapper>
          <StartMeeting onClick={onClickConfirm}>면접 시작하기</StartMeeting>
          <CancelMeeting onClick={onClickCancel}>취소</CancelMeeting>
        </ActionWrapper>
      </Content>
    </Wrapper>
  );
};

export default SolidModal;
